<template>
  <v-layout 
  justify-center
  pt-5
  mt-4
  pb-3>
   <v-flex xs6>
   <v-img
      :src="src"
      />
      </v-flex>
    <v-flex
      xs6  
    >
      <panel title="Password Reset Login">
        <form
          name="login-form"
          autocomplete="on"
        >
          <v-text-field
            v-model="email"
            label="Email associated with your account"
          />
          <v-text-field
            v-model="tempPin"
            label="Enter the pin received in email"
          />
          <br>
          <v-text-field
            v-model="password"
            label="New Password"
            type="password"
            autocomplete="new-password"
          />
          <v-text-field
            v-model="password2"
            label="Re-enter New Password"
            type="password"
            autocomplete="new-password"
          />
        </form>
        <br>
        <p class="headline text-xs-left">
        <b> Copyright Notice</b>
        </p>
        <p class="text-xs-left">
          The Reiss Motivation Profile® (“RMP”) and the RMP Testing Program are protected by copyright as to test content and 
          related materials (e.g., examiner and technical manual), and as a collective work and/or compilation, pursuant to 
          United States (“US”) copyright laws, international conventions, and other foreign national copyright laws.  
          The RMP and the RMP Testing Program also are protected by US trade secret laws.  
          Further, IDS product names and logos are protected under US and international trademark laws.   </p>
        <p class="text-xs-left">
          A user may not copy, memorize for sharing, distribute, publicly display, modify, transmit, reuse, repost, or use for 
          public or commercial purposes, any of the contents of the Reiss Motivation Profile® or the RMP Testing Program without 
          the express written permission of IDS, obtained in writing in advance of such use.  Permission requests should be sent 
          to: <a href="mailto:ids@idspublishing.com">ids@idspublishing.com.</a> A user may not alter or remove this Copyright Notice 
          from any RMP or other IDS materials.
        </p>
        <p class="text-xs-left">
        By clicking the ‘Login’ button, I indicate I have read the above Copyright Notice and hereby acknowledge I agree 
           to be bound by those terms and conditions.
        </p>
        <div
          class="danger-alert"
          v-html="error"
        />
        <br>

        <v-btn
          :color="strongColor" 
          dark
          @click="login"
        >
          Login
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import rmp_tagline from '@/assets/rmp_tagline.png'
import AuthenticationService from '@/services/AuthenticationService'
import {
  STRONG_COLOR, 
  BUSINESS
} from "@/components/globals/consts"

export default {
  data() {
		return {
      agree: false,
			email: '',
			password: '',
      password2: '',
      tempPin: '',
      src: rmp_tagline,
      error: null,
      dialog: false,
      strongColor: STRONG_COLOR,
      testType: BUSINESS,
      screenType: 0
		}
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user"])
  },
  	methods: {
		async login () {
      
      try {
        if (this.password !== this.password2) {
				this.error = 'New passwords do not match.'
			}
        
      const response = await AuthenticationService.resetPassword({
        email: this.email,
        tempPin: this.tempPin,
        password: this.password
      })
        

				await this.$store.dispatch('setToken', response.data.token)
        await this.$store.dispatch('setUser', response.data.user)
        await this.$store.dispatch('setTestType', this.testType)
        await this.$store.dispatch('setScreenType', this.screenType)
        
        this.$router.push({
					name: 'clients'
				})
			} catch (error) {
        try {
        this.error = error.response.data.error
        }
        catch (error) {
          this.error = 'Error but no error message received'
          console.log('Error but no error message received')
        }
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ResetLink.vue